module.exports = __webpack_public_path__ + "static/media/Connemara-bylaws.4056d1dc.pdf";